import { styled } from '@mui/material/styles';

// 레거시 apprAfterConfirmModal(Bootstrap) 외형 복원 — 레거시 레이어와 번갈아 노출되므로 동일 모양 유지

export const Dialog = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 310px;
  background: var(--dk-bg, #fff);
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  outline: none;
`;

export const Header = styled('div')`
  padding: 15px 20px;
  border-bottom: 1px solid var(--dk-line, #e5e5e5);
`;

export const Title = styled('h5')`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--dk-text, #1d2025);
  text-align: left;
`;

export const Body = styled('div')`
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ActionButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone: 'primary' | 'default' }>(({ tone }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  width: '100%',
  padding: '12px',
  borderRadius: 4,
  borderWidth: 1,
  borderStyle: 'solid',
  fontSize: 16,
  lineHeight: '24px',
  cursor: 'pointer',
  ...(tone === 'primary'
    ? {
        background: '#3498db',
        borderColor: '#258cd1',
        color: '#fff',
        '&:hover': { background: '#4aa3df', borderColor: '#4aa3df' },
      }
    : {
        background: 'var(--dk-bg, #fff)',
        borderColor: 'var(--dk-line-strong, #cccccc)',
        color: 'var(--dk-text-primary, #333333)',
        '&:hover': { background: 'var(--dk-bg-muted, #e6e6e6)', borderColor: 'var(--dk-line-strong, #adadad)' },
      }),
}));
